import React from "react";
import { ArrowRightIcon } from "lucide-react";
export function ContactCta() {
  return <section id="contact" className="scroll-mt-24 px-5 py-20 md:px-8 md:py-32" data-id="element-75" data-mp="1eunq9gawagf1">
      <div className="mx-auto max-w-5xl text-center" data-id="element-76" data-mp="1sliozzrojh4w">
        <h2 className="text-5xl font-semibold leading-[1.02] tracking-tightest md:text-[84px]" data-id="element-77" data-mp="1smby37e42iq7">
          Parlons de vos projets.
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-muted md:text-xl" data-id="element-78" data-mp="22jq56ge59v5u">
          Un premier rendez-vous de 45 minutes, gratuit et sans engagement, pour faire le point
          sur votre situation.
        </p>
        <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-5" data-id="element-79" data-mp="2bkod39rpemtp">
          <a href="mailto:contact@lenouveauplacement.com" className="group flex items-center gap-2 whitespace-nowrap rounded-full bg-ink px-7 py-4 text-[17px] font-medium text-canvas transition-transform duration-150 active:scale-[0.97]" data-id="element-80" data-mp="27ijk8d92xu84">
            Prendre rendez-vous
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-81" data-mp="ef5xjpxg2ub" />
          </a>
          <a href="tel:0130359188" className="whitespace-nowrap px-3 py-4 text-[17px] font-medium" data-id="element-82" data-mp="5bxfncbrqm3d">
            01 30 35 91 88
          </a>
        </div>
        <a href="mailto:contact@lenouveauplacement.com" className="mt-4 inline-block text-[15px] text-muted underline-offset-4 hover:text-ink hover:underline" data-id="element-83" data-mp="a9gvggo476xf">
          contact@lenouveauplacement.com
        </a>
      </div>
    </section>;
}